// Персональные почтовые уведомления (SDBL-11). Здесь только письма, которые человек вправе
// отключить. Обязательных (назначение исполнителем, уточнение, выполнение, отказ, системное
// закрытие, SLA) и писем исполнителю в списке нет намеренно: их ключи сервер отклоняет.
export const EMAIL_NOTIFICATION_OPTIONS = [
    { key: 'notifications.email.comment-author', label: 'Новое сообщение в обращении' },
    { key: 'notifications.email.status-progress', label: 'Обращение взято в работу или приостановлено' },
    { key: 'notifications.email.service-changed', label: 'Изменение категории или сервиса обращения' },
    { key: 'notifications.email.observer', label: 'Уведомления по обращениям, где я наблюдатель' },
];

/**
 * Состояние переключателей из ответа GET /account-settings. Выключено только то, что
 * сохранено как false: нет записи или в ней не булево значение — письмо приходит,
 * так же считает и сервер.
 */
export function readEmailNotifications(serverSettings = {}) {
    return EMAIL_NOTIFICATION_OPTIONS.reduce((values, { key }) => {
        values[key] = serverSettings[key] !== false;
        return values;
    }, {});
}

export function emailNotificationSettings(values) {
    return EMAIL_NOTIFICATION_OPTIONS.map(({ key }) => ({ key, value: values[key] !== false, type: 'boolean' }));
}
